export default __webpack_public_path__ + "static/media/fil.68383dca.svg";